import store from '@/store'
import { SSharedAuth } from '@/services'

/* eslint-disable-next-line */
export default async (_to, _from, next) => {
  if (!store.getters['auth/check'] && store.getters['auth/token']) {
    await SSharedAuth.getCurrentUser().then(({ data }) => {
      store.dispatch('auth/fetchUserSuccess', {
        id: data.id,
        email: data.email,
        role: data.role.code,
        role_name: data.role.name,
        username: data.role.username,
        name: data.name,
        budget: data.budget,
        is_approver: data.is_approver
      })
    }).catch(() => {
      store.dispatch('auth/fetchUserFailure')
    })
  }

  next()
}
